export default __webpack_public_path__ + "static/media/movie-img.dc3afe60.webp";